(function(){
 'use strict';
 document.querySelectorAll('[data-photo-option]').forEach(function(option){
  var form=option.parentElement.querySelector('form');
  var back=option.querySelector('[data-photo-back]');
  var link=option.querySelector('[data-photo-link]');
  var loaded=false,timer;
  if(window.Shopify&&Shopify.theme&&Shopify.theme.role!=='main'){
   link.href+='&preview_theme_id='+encodeURIComponent(Shopify.theme.id);
   option.querySelector('[data-photo-qr]').src=option.querySelector('[data-photo-qr]').dataset.draftSrc;
  }
  function value(selector){var field=form&&form.querySelector(selector);return field?field.value:'';}
  function set(field,value){
   if(!field||field.value||!value)return;
   var proto=field.tagName==='TEXTAREA'?HTMLTextAreaElement.prototype:HTMLInputElement.prototype;
   Object.getOwnPropertyDescriptor(proto,'value').set.call(field,String(value));
   field.dispatchEvent(new Event('input',{bubbles:true}));
   field.dispatchEvent(new Event('change',{bubbles:true}));
  }
  function prefill(){
   var host=option.querySelector('shopify-forms-embed');
   var shadow=host&&host.shadowRoot;
   if(!shadow||!shadow.getElementById('email'))return false;
   if(!shadow.getElementById('fmt-photo-readable')){
    var style=document.createElement('style');style.id='fmt-photo-readable';
    style.textContent='input,textarea,button{font-size:16px!important}input:not([type=file]),button,[role=button]{min-height:48px}p,label{font-size:16px!important;line-height:1.5!important}h2{font-size:28px!important;line-height:1.2!important}';
    shadow.appendChild(style);
   }
   if(loaded)return true;
   var message=value('textarea[name="contact[body]"]');
   var context=value('[data-enq-summary]');
   var media=value('select');
   var phone=value('input[type="tel"]');
   if(media)message+='\nMedia: '+media;
   if(phone)message+='\nPhone: '+phone;
   if(context)message+='\nProject so far: '+context;
   set(shadow.getElementById('first_name'),value('input[name="contact[name]"]').slice(0,100));
   set(shadow.getElementById('email'),value('input[type="email"]'));
   set(shadow.querySelector('textarea[name="custom#how_can_we_help"]'),message.slice(0,2000));
   loaded=true;return true;
  }
  option.addEventListener('toggle',function(){
   if(form)form.hidden=option.open;
   clearInterval(timer);
   if(option.open&&!prefill()){
    var tries=0;timer=setInterval(function(){if(prefill()||++tries>40)clearInterval(timer);},500);
   }
  });
  back.addEventListener('click',function(){option.open=false;option.querySelector('summary').focus();});
 });
})();
